// extracted by mini-css-extract-plugin
export default {"Month":"zqBEX","title-wrap":"_1Bko-","title":"KjaSK","year":"p6bpN","skeleton-progress":"Oqp6c"};